import React, { useEffect, useState } from "react";
import style from './ProgressTracker.module.scss';
import ProgressItem from './Item'
import { filterProgressTracker } from '../../../store/actions/programs.actions'
import $ from "jquery";
import { useDispatch } from "react-redux";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { getEditPermission, resetUtcDate } from "../../../helpers/utils";
import { LockSvg, ArrowLeft, ArrowRight, CalendarIcon } from "../../../modules/default-svg";
import moment from "moment/moment";
dayjs.extend(utc);

const ProgressTracker = (props) => {
    const { programId, programProgress, updateProgressKPI, getProgressTracker, handleUpdatePeriod } = props;
    const [progressTracker, setProgressTracker] = useState([]);
    const [progressTrackerPeriod, setProgressTrackerPeriod] = useState('');
    const [progressTrackerMaxLines, setProgressTrackerMaxLines] = useState(0);
    const settings = JSON.parse(localStorage.getItem("settings"));
    const [setting] = useState(settings);
    const [readOnly, setReadOnly] = useState(false);
    const dispatch = useDispatch();
    const progressTrackerMaxLineLength = 100;
    const handleUpdateProgress = (payload) => {
        updateProgressKPI({
            id: programId,
            payload: {...payload, programId: programId}  });
    }

    const addDays = (date, days) => moment(date, "YYYY-MM-DD").add(days, "days").format("YYYY-MM-DD");
    const subtractDays = (date, days) => addDays(date, -days);

    const handleCurrent = () => {
        const data = { date: subtractDays(programProgress?.period?.startCurrent, 7) };
        programId && dispatch(filterProgressTracker({ id: programId, data }));
    };

    const handleTrending = () => {
        const data = { date: addDays(programProgress?.period?.endCurrent, 7) };
        programId && dispatch(filterProgressTracker({ id: programId, data }));
    };

    useEffect(() => {
        getProgressTracker(programId);
    }, []);

    useEffect(() => {
        if(programProgress) {
            setProgressTracker(programProgress.data);
            setProgressTrackerPeriod(programProgress.period);
            setProgressTrackerMaxLines(programProgress.maxLines);
            const data = {
                startCurrent: programProgress.period ? moment(programProgress.period?.startCurrent).toDate(): '',
                endCurrent: programProgress.period ? moment(programProgress.period?.endCurrent).toDate() : '',
            };

            if(programProgress.period?.startCurrent && programProgress.period?.endCurrent) {
                $("input[name='datetimes']").daterangepicker({
                    startDate: data.startCurrent,
                    endDate: data.endCurrent,
                    locale: {
                        format: setting.regionalSettings.dateFormat.toUpperCase()
                    }
                });
                handleUpdatePeriod(moment(programProgress.period?.endCurrent).format('YYYY-MM-DD'));
            }

            $("input[name='datetimes']").on('apply.daterangepicker', (e, picker) => {
                const newStartDate = picker.startDate.format('YYYY-MM-DD');
                dispatch(filterProgressTracker({ id: programId, data: { date: newStartDate } }));
            });

            setReadOnly(!getEditPermission("Program") || programProgress?.isDisabled);
            return () => {
                $("input[name='datetimes']").daterangepicker('destroy');
            };
        }
    }, [programProgress]);

    return (
        <>
            <div className={style.mainScroller}>
                <div className={style.leftBarContent}>
                    <button
                        type="button"
                        className={`${style.hsHeaderArrow}`}
                        onClick={handleCurrent}
                    >
                        <ArrowLeft />
                    </button>
                    <div className={style.rangeDateWrapper}>
                        <input
                            type="text"
                            className={style.rangeDateInput}
                            name="datetimes"
                        />
                        <CalendarIcon />
                    </div>
                    <button
                        type="button"
                        className={`${style.hsHeaderArrow}`}
                        onClick={handleTrending}
                    >
                        <ArrowRight />
                    </button>
                </div>
                <div className="row gx-3">
                    <div className="col-4">
                        <ProgressItem 
                            kpi={0}
                            maxLines={progressTrackerMaxLines}
                            maxLineLength={progressTrackerMaxLineLength}
                            title="Accomplishment's Highlights" 
                            placeholder="Accomplished highlights is empty"  
                            period={progressTracker?.find(d => d.kpi == 0)?.period} 
                            item={progressTracker?.find(d => d.kpi == 0)?.description ?? ''}
                            updateStatus={(e) => handleUpdateProgress(e)} 
                            disabled={readOnly}/>
                    </div>
                    <div className="col-4">
                        <ProgressItem 
                            kpi={1}
                            maxLines={progressTrackerMaxLines}
                            maxLineLength={progressTrackerMaxLineLength}
                            title="Focus for Next Period" 
                            placeholder="Focus for Next Period is empty" 
                            period={progressTracker?.find(d => d.kpi == 1)?.period} 
                            item={progressTracker?.find(d => d.kpi == 1)?.description ?? ''} 
                            updateStatus={(e) => handleUpdateProgress(e)} 
                            disabled={readOnly}/>
                    </div>
                    <div className="col-4">
                        <ProgressItem 
                            kpi={2}
                            maxLines={progressTrackerMaxLines}
                            maxLineLength={progressTrackerMaxLineLength}
                            title="Risks & Issues Focus" 
                            placeholder="Risks & Issues Focus is empty" 
                            period={progressTracker?.find(d => d.kpi == 2)?.period} 
                            item={progressTracker?.find(d => d.kpi == 2)?.description ?? ''} 
                            updateStatus={(e) => handleUpdateProgress(e)} disabled={readOnly}/>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ProgressTracker;